<template>
  <div class="w-full px-0 cursor-pointer  md:px-2">
    <a
      class="flex flex-row pb-6 mt-6 border-b md:flex-row border-neutral-400 md:justify-between"
      @click="goToTopicDetail"
    >
      <div v-if="!topic.userAuthor.photoProfile" class="hidden md:block">
        <img
          class="object-cover w-12 h-12 mr-6 rounded-full cursor-pointer"
          src="@/assets/images/user-topic.svg"
          alt="user"
        />
      </div>
      <div v-else-if="topic.userAuthor.photoProfile" class="hidden md:block">
        <img
          class="object-cover w-12 h-12 mr-6 rounded-full cursor-pointer"
          :src="topic.userAuthor.photoProfile.path"
          alt="user"
        />
      </div>
      <div class="flex flex-col w-full md:flex-row">
        <main class="flex flex-col w-full">
          <h6 class="text-base font-bold text-black break-all">
            {{ topic.title }}
          </h6>
          <span class="min-h-[23px] mt-2 border-l-2 border-h-primary-500">
            <p
              class="p-1 text-xs font-semibold bg-neutral-100 w-fit text-h-primary-500 text-wrap"
            >
              {{ topic.tag }}
            </p>
          </span>
          <p class="mt-2 text-sm font-semibold text-neutral-700">
            {{
              $t("labels.generic", {
                pt: "Publicado",
                en: "Published",
              })
            }}
            {{ timeSinceCreation }}
            {{
              $t("labels.generic", {
                pt: "por",
                en: "by",
              })
            }}
            {{ topic.userAuthor.name }}
          </p>
        </main>
        <footer
          class="flex items-center justify-between mt-4 md:mt-0 md:ml-6 md:flex-col"
        >
          <span class="flex items-center self-end gap-2 w-fit h-fit md:mb-4">
            <v-icon
              name="md-chatbubbleoutline-round"
              class="text-neutral-600"
              scale="1.3"
            />
            <p class="pr-4 mr-1 text-base font-bold text-neutral-600">
              {{ topic.commentAmount }}
            </p>
            <v-icon name="pr-thumbs-up" scale="1.3" class="text-neutral-600" />
            <p class="text-base font-bold text-neutral-600">
              {{ topic.likeAmount }}
            </p>
          </span>
          <div
            v-if="topic.status === status.SOLVED"
            class="flex flex-row items-center self-end px-1 bg-h-success-50 w-fit h-7"
          >
            <v-icon
              name="md-check-round"
              scale="0.9"
              class="text-h-success-500"
            />
            <p class="ml-1 text-xs font-semibold text-h-success-500">
              {{
                $t("labels.generic", {
                  pt: "RESOLVIDO",
                  en: "SOLVED",
                })
              }}
            </p>
          </div>
          <div
            v-if="topic.status  === status.CLOSED"
            class="flex flex-row items-center self-end px-1 bg-h-neutral-200 w-fit h-7"
          >
            <v-icon
              name="io-checkmark" 
              scale="0.9"
            />
            <p class="ml-1 text-xs font-semibold text-h-neutral-800">
              {{
                $t("labels.generic", {
                  pt: "ENCERRADO",
                  en: "CLOSED",
                })
              }}
            </p>
          </div>
        </footer>
      </div>
    </a>
  </div>
</template>
<script lang="ts">
import { StatusTopic, Topic } from "@/models/topic.model";
import { defineComponent, PropType } from "vue";
import moment from "moment";
import { GoToRoute } from "@/utils/go-to.util";

export default defineComponent({
  name: "topicCard",
  props: {
    topic: {
      type: Object as PropType<Topic>,
      required: true,
    },
  },
  data() {
    return {
      status: StatusTopic
    }
  },
  methods: {
    goToTopicDetail(): void {
      this.go.redirectToPage("topicDetail", { topicId: this.topic.id });
    },
  },
  computed: {
    timeSinceCreation(): string {
      // moment.locale(navigator.language);
      moment.locale("pt-br");
      return moment(this.topic?.createdAt).add(3, "hour").fromNow();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
  },
});
</script>
